<template>
  <div class="ui-legend">
    <div class="ui-legend__item" v-for="(legend, idx) in legends" :key="`legend-${idx}`">
      <div class="ui-legend__item__color" :style="{ backgroundColor: legend.color }"></div>
      <div class="ui-legend__item__name">
        {{ legend.name[$i18n.locale] || legend.name.default }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiLegend',
  props: {
    legends: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.ui-legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: -4px -8px;

  &__item {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    width: calc(100% / 3);

    @media (min-width: $screen-sm) {
      width: calc(100% / 4);
    }

    @media (min-width: $screen-xl) {
      width: calc(100% / 5);
    }

    &__color {
      margin-right: 8px;
      border-radius: 50%;
      width: 12px;
      height: 12px;
    }

    &__name {
      flex: 1;
      font-size: $font-size-sm;
    }
  }
}
</style>
